import type { ReactNode } from 'react';

export const symbol_call_received: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-200q-13 0-21.5-8.5T200-230v-336q0-13 8.5-21.5T230-596q13 0 21.5 8.5T260-566v264l477-477q9-9 21-9t21 9q9 9 9 21t-9 21L302-260h264q13 0 21.5 8.5T596-230q0 13-8.5 21.5T566-200H230Z"
		/>
	</svg>
);
